<template>
  <div>
    <Modal
      class="editBlock modalqkmsg"
      v-model="modal"
      :title="newqkmsgstatus ? '新增问答' :'编辑问答'"
      width="45"
      footer-hide
    >
      <div class="bodyhigh">
        <div class="bodytwice">
          <div class="content">
            <Row>
              <Col :xs="{span:24}" :lg="{span:12}">
                <label>标题</label>
                <Input class="editInput comapny-name" v-model="form.title" type="text"></Input>
              </Col>
              <Col :xs="{span:24}" :lg="{span:12}" class="clas" v-if="clas.length">
                <label>分类</label>
                <div style="display:inline">
                  <Select v-model="form.clas" :transfer="true">
                    <Option
                      v-for="(item, idx) in clas"
                      :value="item.gupid"
                      :key="idx"
                    >{{item.gupname}}</Option>
                  </Select>
                </div>
              </Col>
            </Row>
            <div class="bodytwice-bottom">
              <label class="qkmsgContentLabel">内容</label>
              <Input
                class="qkmsgContent"
                type="textarea"
                v-model="form.innertext"
                :autosize="{minRows: 5,maxRows: 5}"
              ></Input>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div v-if="!newqkmsgstatus" class="btn" @click="editConfirm">储存</div>
          <div v-if="newqkmsgstatus" class="btn" @click="addConfirm">提交</div>
          <div class="btn" @click="reset">重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "ModalQkmsg",
  props: {
    qkmsgstatus: {
      type: Boolean,
      required: true
    },
    clas: {
      type: Array,
      required: true
    },
    newqkmsgstatus: Boolean,
    qkmsgItem: Object,
  },
  data () {
    return {
      form: {
        title: "",
        clas: "",
        innertext: ""
      },
      clasName: "",
      tempoqkmsgItem: {},
    }
  },
  computed: {
    ...mapGetters(["username"]),
    modal: {
      get () {
        return this.qkmsgstatus
      },
      set (val) {
        this.reset()
        this.$emit("update:qkmsgItem", {})
        this.$emit("update:qkmsgstatus", val)
        this.$emit("update:newqkmsgstatus", false)
      }
    }
  },
  watch: {
    qkmsgItem () {
      this.tempoqkmsgItem = JSON.parse(JSON.stringify(this.qkmsgItem))
      this.form.clas = this.tempoqkmsgItem.clas
      this.form.title = this.tempoqkmsgItem.title
      this.form.innertext = this.tempoqkmsgItem.innertext
    },
  },
  methods: {
    //提交确定
    addConfirm () {
      const check = Object.keys(this.form).some(it => !this.form[it])
      if (check) return this.$Message.error('每个栏位皆需填入内容');
      let obj = {
        maid: Number(this.username.maid),
        ...this.form
      };
      this.$axios
        .qkmsgins(obj)
        .then(res => {
          this.$emit("getQkmsg")
          this.reset()
        })
        .catch(err => console.error(err))
      this.modal = false
    },
    //编辑确定
    editConfirm () {
      const check = Object.keys(this.form).some(it => !this.form[it])
      if (check) return this.$Message.error('每个栏位皆需填入内容');
      let obj = {
        maid: Number(this.username.maid),
        id: this.qkmsgItem.id,
        ...this.form
      };
      this.$axios
        .qkmsgupd(obj)
        .then(res => {
          this.$emit("getQkmsg")
          this.reset()
        })
        .catch(err => console.error(err));
      this.modal = false
    },

    //reset
    reset () {
      this.form.title = ''
      this.form.clas = ''
      this.form.innertext = ''
    }
  }
}
</script>
<style lang="less">
.modalqkmsg {
  .ivu-input {
    height: 40px;
  }
  .ivu-select {
    width: 75%;
    margin-left: 10px;
    position: static;
  }
  .ivu-select-selection {
    height: 40px;
    .ivu-select-placeholder,
    .ivu-select-selected-value {
      line-height: 40px;
    }
  }
  .clas {
    margin-bottom: 0;
    transform: translateY(7px);
  }
  .qkmsgContent {
    margin-left: 10px;
  }
  .qkmsgContentLabel {
    display: inline-block;
    transform: translateY(-40px);
  }
  .qkmsgContent {
    width: 88%;
  }
}
@media screen and (max-width: 992px) {
  .modalqkmsg {
    .ivu-modal-body .bodytwice .content {
      padding-left: 10px;
      padding-right: 10px;
    }
    .editInput {
      width: 83%;
    }
    .clas {
      width: 111%;
    }
    .bodytwice-bottom {
      margin-top: 20px;
      .qkmsgContent {
        width: 83%;
      }
    }
  }
}
</style>